<app-material>
    <ng-container header>
        <div class="header">
            <h2>{{ 'admin.lines.table.title' | translate }}</h2>
            <div class="mutators">
                <app-button *ngIf="shouldRenderModifiers()"
                            (click)="openLineModal()">{{ 'admin.lines.buttons.addLine' | translate }}
                </app-button>
                <app-button (click)="onDownloadLineReport()">
                    {{ 'reportDownloadForm.downloadButton' | translate }}
                </app-button>
            </div>
        </div>
    </ng-container>
    <ng-container body>
        <app-lines-table [lines]="lines"
                         [hasTitle]="false"
                         [tableConfig]="tableConfig"
                         [isLoading]="isLoadingLines"
                         [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                         (sortChange)="onSortChange($event)"
                         (filterChange)="onFilter($event)"
                         (rowClick)="onTableRowClick($event)"
                         (duplicateRow)="onDuplicateRow($event)"
                         (pageChange)="onPageChange($event)">
        </app-lines-table>
    </ng-container>
</app-material>

<app-line-create-modal
    [isReadyOnly]= "!shouldRenderModifiers()"
    [isLoading]="isLoadingLines"
    (onCreate)="create($event)"
    (onUpdate)="update($event)"
    (onDelete)="remove($event)">
</app-line-create-modal>
